const logs = {
    page_title: "Journaux d'audit",
    title: "Journaux d'audit",
    subtitle: "Visualisez les données du journal des événements d'authentification effectués par votre administrateur et vos utilisateurs.",
    event: 'Événement',
    user: 'Utilisateur',
    application: 'Application',
    time: 'Temps',
    filter_by: 'Filtrer par',
    last_1_hour: 'Dernière heure',
    last_24_hours: 'Dernières 24 heures',
    last_7_days: '7 derniers jours',
    last_30_days: '30 derniers jours',
    custom_range: 'Plage personnalisée',
    from: 'Du',
    to: 'Au',
};
export default Object.freeze(logs);
